<div class="header col gap-16">
    <img src="/images/default-agent.png" alt="Default Johnny Image" />
    <div class="col gap-4" i18n>
        <div class="uppercase-label">Hello there, Johnny here</div>
        <h2>Hold on—there’s still more to discuss.</h2>
        <div>The following still needs more discussion.</div>
    </div>
</div>
<div class="col gap-16 questions">
    @for(e of data.questions; track e.question; let i = $index){ @if(e.resolved
    === false){
    <div class="row gap-8 align-start">
        <rr-icon name="arrow-right" class="w24" color="nutral"></rr-icon>
        <div class="col">
            <h4 class="strong">{{ e.question }}</h4>
            <div class="">{{ e.description }}</div>
            <div class="link tiny" (click)="close(i)">Discuss with Johnny</div>
        </div>
    </div>
    } }
</div>
<div class="btnarea w100 justify-end row gap-8" i18n>
    @if(data.state === OpenQuestionDialogState.NEXT){
    <rr-btn type="Secondary" (click)="ignore()">Proceed Anyway</rr-btn>
    }
    <rr-btn type="Primary" (click)="close()" cdkFocusInitial>Return to Chat</rr-btn>
</div>
